<template>
    <div class="info-container">
        <div class="info-title">
            {{title}}
        </div>
        <router-link class="info-item button"
             :to="item.link"
             v-for="(item, index) in contents"
             :key="index">
            <span class="info-tag"></span>
            <span class="info-details"
               :href="item.link">
                {{item.details}}
            </span>
        </router-link>
    </div>
</template>

<script>
	export default {
		name: "InfoBlock",
		props: {
			title: {
				type: String,
				required: true
			},
			contents: {
				type: Array,
				required: true
			}
		},
		data() {
			return {}
		}
	}
</script>

<style scoped lang="scss">

    .info-container {
        position: relative;
        box-sizing: border-box;
        text-align: left;
        padding-top: 64px;
        width: 100%;
    }

    .info-title {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 48px;
        font-size: 36px;
        line-height: 48px;
        font-weight: 700;
        font-family: $serif;
        overflow-y: hidden;
        border-bottom: $dotted;
    }

    .info-item {
        display: flex;
        flex-flow: row nowrap;
        text-decoration: none;
        color: $p-fg;
        align-items: center;
        text-align: left;
        padding: 16px;
        margin-top: 4px;

        @media #{$tablet} {
            margin-top: 8px;
        }

        @media #{$tablet-inv} {
            margin-top: 8px;
        }
    }

    .info-tag {
        display: inline-block;;
        width: 8px;
        min-width: 8px;
        margin-right: 8px;
        background-color: $p-accent;
        height: 8px;
    }
</style>